/** @format */
import { css } from 'styled-components';

import { CriteriaBoxProps } from './index';

/**
 * Base styles for the CriteriaBox component
 */
const baseStyles = (props: CriteriaBoxProps) => css`
    display: inline-flex;
    align-items: center;
    font-size: 1.2rem;
    padding: 0.9rem 0.8rem 0.9rem 1.2rem;
    background: var(--colors-surface-primary);
    border-radius: 0.6rem;
    border: var(--effect-border-md) solid var(--colors-border-secondary);
    color: var(--colors-text-secondary);

    &:hover {
        background: var(--colors-surface-tertiary);
    }

    button {
        position: relative;
        top: 0.1rem;
        height: auto;
        margin: 0 0 0 0.6rem;
    }
`;

/**
 * The CriteriaBox component styles
 *
 * @param {CriteriaBoxProps} props The criteria-box properties object
 */
export const styles = (props: CriteriaBoxProps) => css`
    ${baseStyles(props)}
`;
